import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const PasswordComplexityError = BaseErrorSchema.extend({
  errorType: z.literal('PasswordComplexityError'),
});

export type PasswordComplexityError = z.infer<typeof PasswordComplexityError>;
